import script from "./teachingNotices.vue?vue&type=script&setup=true&lang=js"
export * from "./teachingNotices.vue?vue&type=script&setup=true&lang=js"

import "./teachingNotices.vue?vue&type=style&index=0&id=05b41ebc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b41ebc"]])

export default __exports__